import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liv-loading-message',
  templateUrl: './loading-message.component.html',
  styleUrls: ['./loading-message.component.scss'],
  standalone: false
})
export class LoadingMessageComponent {
  @Input() hasError: boolean;
  @Input() lightMode: boolean;
  @Input() title = 'messages.there_is_problem';
  @Input() message = 'messages.content_failed';

  @Output() tryAgain = new EventEmitter();

  onRetry(): void {
    if (this.hasError) {
      this.hasError = false;
    }
    this.tryAgain.emit(this.hasError);
  }
}
